var map = {
	"./google-play-badge-da-DK.svg": 46517,
	"./google-play-badge-de-DE.svg": 90351,
	"./google-play-badge-en-GB.svg": 29949,
	"./google-play-badge-en-US.svg": 44594,
	"./google-play-badge-es-ES.svg": 69521,
	"./google-play-badge-es-MX.svg": 96306,
	"./google-play-badge-fr-FR.svg": 86485,
	"./google-play-badge-it-IT.svg": 45023,
	"./google-play-badge-nb-NO.svg": 79560,
	"./google-play-badge-nl-NL.svg": 72429,
	"./google-play-badge-pl-PL.svg": 29393,
	"./google-play-badge-pt-BR.svg": 86993,
	"./google-play-badge-pt-PT.svg": 70657,
	"./google-play-badge-sv-SE.svg": 89396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;